/**
 * Mix multiple MediaStreams (audio only) into a single output MediaStream using WebAudio.
 * Returns the mixed stream and a cleanup function.
 */
export function mixAudioStreams(streams: MediaStream[]): { stream: MediaStream; stop: () => void } {
  const AudioCtx = (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext);
  const ctx = new AudioCtx();
  const dest = ctx.createMediaStreamDestination();
  const sources: MediaStreamAudioSourceNode[] = [];

  for (const s of streams) {
    if (!s || s.getAudioTracks().length === 0) continue;
    try {
      const src = ctx.createMediaStreamSource(s);
      src.connect(dest);
      sources.push(src);
    } catch (e) {
      console.warn('mixAudioStreams: could not connect stream', e);
    }
  }

  return {
    stream: dest.stream,
    stop: () => {
      sources.forEach(s => { try { s.disconnect(); } catch { /* ignore */ } });
      try { dest.disconnect(); } catch { /* ignore */ }
      ctx.close().catch(() => { /* ignore */ });
    },
  };
}